import { Link } from "react-router-dom";

import { DESIGN_PARTNER_PATHS } from "../routes";

export function SecurityPage() {
  return (
    <section className="page" id="security" data-testid="dp-page-security">
      <div className="wrap policy">
        <div className="eyebrow">Trust</div>
        <h1>Security approach</h1>
        <p>
          Zephix is being built for organizations that need confidence in project data, access
          boundaries, and governed decisions. During the design-partner phase, we are validating our
          security controls alongside core workflow reliability.
        </p>
        <h2>Current commitments</h2>
        <ul>
          <li>Tenant-scoped access controls are a core product requirement.</li>
          <li>Role-based permissions are designed around least privilege.</li>
          <li>Design-partner access is controlled rather than self-serve.</li>
          <li>
            Governed workflows are intended to provide visible approval history for relevant project
            decisions.
          </li>
          <li>
            AI product direction is advisory: people remain accountable for actions and decisions.
          </li>
        </ul>
        <h2>Questions and due diligence</h2>
        <p>
          Security documentation, pilot data-handling expectations, and product-control discussions
          will be provided directly to qualified design partners as the product reaches the
          appropriate readiness stage. Contact us through the{" "}
          <Link to={DESIGN_PARTNER_PATHS.contact}>Contact page</Link>.
        </p>
      </div>
    </section>
  );
}
